import { Global } from 'src/app/Service/global.service';
import { PortMarocService } from '../../../Service/port-maroc.service';

import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Observable } from 'rxjs';
declare var $: any;

@Component({
  selector: 'app-all-port-maroc',
  templateUrl: './port-detail.component.html',
  styleUrls: ['./port-detail.component.scss']
})
export class PortDetailComponent implements OnInit {
regions = [];
ports = [];
menuPort = [];
selectedPort = '';
currentPort ;
routePort = '';
currentlg='';
showAllPort = true;
currentBanniere = '';
currentUrl = '';
subscribe;
isArab=false;
  constructor(private global:Global, private portService: PortMarocService, private router: Router, private route:ActivatedRoute) { }

  ngOnInit(): void {
    
   
     this.global.CurentLanguage.subscribe(lg => {
      this.ports = [];
      this.regions = [];
      this.currentlg = lg.code
      lg.code=="ar"?this.isArab=true:this.isArab=false;
    this.portService.getPortData().subscribe(datas => {
     
      datas['value'].forEach(element => {
       
        const obj = {
          port: element.CodePort, 
          pathPort : element.CodePort.toLowerCase().split('ports.port')[1],
          region: element.CodeRegion,
          idPort: element.IdPort,
          img: element.AttachmentFiles.length > 0 ? this.global._baseUrlRacine + element.AttachmentFiles[0].ServerRelativeUrl : ''
        };
        this.ports.push(obj);
        if(this.regions.indexOf(element.CodeRegion) === -1) {
          this.regions.push(element.CodeRegion);
        }
      });
      this.route.params.subscribe(param => {
        this.currentUrl =this.router.url;
        if(param['port'] !== undefined && param['port']!== null && param['port'] !== '' ) {
          this.showAllPort= false;
          this.ports.forEach(element => {
            
            if(element.pathPort === param['port'].toLowerCase()) {
              this.routePort = element.pathPort
              this.selectedPort = element.port
              this.currentPort = element;
                            this.currentBanniere =  element.img;
              this.getPortMenu()
            } 
          });
          if(this.selectedPort === '') {
            
              alert('Le port n\'existe pas ');
              this.router.navigate(['/portinfo']);
            
          }
        } else {
          this.showAllPort = true;
        }
       });
     });
   
    });
  }

  getPortMenu(){
    // Get Menu  Port
  this.menuPort = [];
    this.portService.getMenuData().subscribe(datas => {
      const requests = [];
      const menuDynamique = [];
      datas['value'].forEach(element => {
        
        if(element.PageDynamique) {
          let menuTitle = '';
          if(this.currentlg === 'fr') {
            menuTitle = element.Title
          } else if(this.currentlg === 'ar') {
           menuTitle =element.TitreAR
         } else  {
           menuTitle = element.TitreEN
         }
         const obj = {
           title: menuTitle, 
           url : element.ApplicationUrl,
           Ordre: element.Ordre,
           item: null

         }
         if(obj.url !=='MouvementNavires'  || (obj.url ==='MouvementNavires' && this.currentPort.idPort !== null && this.currentPort.idPort !== undefined))
         { this.menuPort.push(obj);
        }
        } else {
          menuDynamique.push(element);
          requests.push(this.portService.getMenuPageData(this.selectedPort, element.ListeReference,this.currentlg));
        }
      });
      
      forkJoin(requests).subscribe(dataItems => {
        let i = 0;
        dataItems.forEach(list => {
          
          if(list['value'].length > 0) {
           let menuTitle = '';
           if(this.currentlg === 'fr') {
             menuTitle = menuDynamique[i].Title
           } else if(this.currentlg === 'ar') {
            menuTitle = menuDynamique[i].TitreAR
          } else  {
            menuTitle = menuDynamique[i].TitreEN
          }
          const obj = {
            title: menuTitle, 
            url : menuDynamique[i].ApplicationUrl,
            Ordre: menuDynamique[i].Ordre,
            item: list['value']

          }

            this.menuPort.push(obj);
          
          }
          i++;
        });
      
     
        this.menuPort.sort(function(a, b) {
          return a.Ordre - b.Ordre;
        }); 
        
       // this.router.navigate(["page", this.menuPort[0].url], {relativeTo: this.route});
      //  this.currentUrl =this.menuPort[0].url; 
     

      });  
  
     
        
      });
  
  }


     
      


}
